export default __webpack_public_path__ + "static/media/coach-bundle_gray@2x.9d4cf99e.jpg";